<template>
  <div>
    <search-wechat-flow @submit="submitSearch" ref="searchForm" />

    <div class="custom-table-operation-buttons">
      <a-space>
        <a-button type="primary" @click="download">下载</a-button>
      </a-space>
    </div>

    <a-table
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :pagination="false"
      row-key="id"
      @change="sortChange"
    />

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />

  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import SearchWechatFlow from '@/views/fee_data/wechat_flows/Search'
import { findWechatFlowDownloadData, findWechatFlows } from '@/api/fee_detail'
import { formatCurrency } from '@/utils/filter'
import { downLoadExcel } from '@/utils/downLoadExcel'

export default {
  name: 'WechatFlows',
  components: {
    Pagination,
    SearchWechatFlow
  },
  data() {
    return {
      query: { effective: 'true' },
      data: [],
      loading: true,
      previewVisible: false,
      pagination: {
        total_count: 0
      },
      sort: {
        sort_field: '',
        sort_order: ''
      }
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    columns() {
      return [
        {
          title: '微信支付单号',
          dataIndex: 'out_trade_no',
          width: 260,
          fixed: 'left'
        },
        {
          title: '微信订单号',
          width: 220,
          dataIndex: 'prepay_id'
        },
        {
          title: '微信支付商户号',
          width: 150,
          dataIndex: 'mch_id'
        },
        {
          title: '交易状态',
          width: 130,
          dataIndex: 'status'
        },
        {
          title: '订单金额(元)',
          width: 130,
          dataIndex: 'fee',
          customRender: formatCurrency
        },
        {
          title: '支付用户',
          width: 120,
          dataIndex: 'pay_user'
        },
        {
          title: '联系电话',
          width: 150,
          dataIndex: 'phone_number'
        },
        {
          title: '关联平台订单号',
          width: 220,
          dataIndex: 'order_no'
        },
        {
          title: '创建时间',
          dataIndex: 'create_time',
          width: 180
        }
      ]
    }
  },
  methods: {
    submitSearch(search) {
      // 赋值搜索条件，保留 per_page
      this.query = Object.assign({},
        this.$options.data().query,
        search)
      // 重置排序
      this.sort = this.$options.data().sort
      this.fetchData()
    },

    sortChange(pagination, filters, sorter) {
      this.sort.sort_field = sorter.field
      this.sort.sort_order = sorter.order
      // 跳转第一页
      this.query.page = 1
      this.fetchData()
    },

    download() {
      findWechatFlowDownloadData(Object.assign({}, this.query, this.sort)).then((res) => {
        if (res.code === 0) {
          const header = `微信支付单号,微信订单号,微信支付商户号,交易状态,订单金额(元),支付用户,联系电话,关联平台订单号,创建时间\n`
          downLoadExcel(header, res.data, '微信小程序流水')
        }
      })
    },

    fetchData() {
      this.loading = true
      findWechatFlows(Object.assign({}, this.query, this.sort)).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loading = false
      })
    }
  }
}
</script>
